import { useEffect, useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import ChangePassword from '../components/ChangePassword';
import LoadingOverlay from '../components/LoadingOverlay';
import { API } from '../utils/axiosConfig';
import { useAuth } from '../context/AuthContext';

const PasswordReset = () => {
	const { email, code } = useParams();
	console.log(email, code);
	const [showForm, setShowForm] = useState(false);
	const api = API();
	const navigate = useNavigate();
	const { user } = useAuth();

	useEffect(() => {
		if (code) {
			//verify code is still active, if it is still active show the change password component
			api
				.post('/auth/verifyCode', { email: email, code: code })
				.then((res) => {
					if (res.status === 200) {
						setShowForm(true);
					}
				})
				.catch((err) => {});
		} else {
			console.log('Code missing');
		}
	}, [code]);

	const goHome = () => {
		navigate('/');
	};

	return (
		<div className="page">
			<Container className="mt-4 mb-4">
				<Row>
					<Col md={{ span: 6, offset: 3 }}>
						{showForm ? <ChangePassword goHome={goHome} /> : <LoadingOverlay />}
					</Col>
				</Row>
			</Container>
		</div>
	);
};
export default PasswordReset;
